import * as React from 'react'
import { Link } from 'react-router-dom'
import { Paths } from '@logic'
import { MarketingHeader } from '@src/modules/marketing/components/marketing-header'
import { MarketingFooter } from '@src/modules/marketing/components/marketing-footer'

const styles: Record<string, React.CSSProperties> = {
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
  main: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4rem 1.5rem',
    textAlign: 'center',
  },
  errorCode: {
    fontSize: '7rem',
    fontWeight: 700,
    lineHeight: 1,
    margin: '0 0 0.5rem',
    color: 'rgba(255,255,255,0.15)',
    letterSpacing: '-0.05em',
  },
  heading: {
    fontSize: '1.75rem',
    fontWeight: 600,
    margin: '0 0 0.75rem',
  },
  subtitle: {
    fontSize: '1rem',
    color: '#9CA6AD',
    margin: '0 0 2rem',
    maxWidth: 420,
  },
  linkRow: {
    display: 'flex',
    gap: '1rem',
    flexWrap: 'wrap' as const,
    justifyContent: 'center',
  },
  primaryLink: {
    padding: '0.6rem 1.4rem',
    background: '#33AA40',
    color: '#fff',
    borderRadius: 6,
    textDecoration: 'none',
    fontWeight: 600,
    fontSize: '0.9rem',
  },
  ghostLink: {
    padding: '0.6rem 1.4rem',
    border: '1px solid rgba(255,255,255,0.2)',
    color: 'inherit',
    borderRadius: 6,
    textDecoration: 'none',
    fontSize: '0.9rem',
  },
}

export function NotFound() {
  return (
    <div style={styles.wrapper}>
      <MarketingHeader />
      <main style={styles.main}>
        <p style={styles.errorCode}>404</p>
        <h1 style={styles.heading}>Page not found</h1>
        <p style={styles.subtitle}>
          The page you're looking for doesn't exist or has been moved. Here are a few links that
          might help:
        </p>
        <div style={styles.linkRow}>
          <Link to="/" style={styles.primaryLink}>Go home</Link>
          <Link to={Paths.userLogin} style={styles.ghostLink}>Sign in</Link>
          <a href="mailto:support@equa.cc" style={styles.ghostLink}>Contact support</a>
        </div>
      </main>
      <MarketingFooter />
    </div>
  )
}
